import { render, staticRenderFns } from "./DateColumn.vue?vue&type=template&id=1f571d75&"
import script from "./DateColumn.vue?vue&type=script&lang=js&"
export * from "./DateColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports